<script setup lang="ts">
import { CustomMarker } from 'vue3-google-map';
import type { GoogleMapLatLngLiteral } from '@global-types/googleMap.ts';

interface Props {
  location: GoogleMapLatLngLiteral,
  zIndex?: number,
}

defineProps<Props>();
</script>

<template>
  <CustomMarker
    :options="{
      position: location,
      anchorPoint: 'CENTER',
      zIndex,
    }"
  >
    <div
      :class="[
        'rounded-full shadow-[0_0_4px_rgb(0_0_0/0.3)]',
        'size-6',
        'bg-blue/20',
        'flex items-center justify-center',
      ]"
    >
      <span
        :class="[
          'rounded-full',
          'size-3',
          'bg-blue',
          'pointer-events-none',
        ]"
      />
    </div>
  </CustomMarker>
</template>
